/* eslint-disable */
import styles from './style.module.scss';
import { t } from '@web-solutions/module-localization';
import Button from '../button/Button';
import Analytics from '@web-solutions/module-analytics';
import { useNav } from 'src/onboarding/hooks/nav';
import { Text } from '../../typography/Text/Text';

export const GetSelfieReportPopup = ({ isOpen, onClose }) => {
  const { currentIndex } = useNav();

  if (!isOpen) {
    return null;
  }

  const handleContinue = () => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
      popup: 'get-selfie-report-popup',
    });
    onClose();
  };

  return (
    <>
      <div className={styles.overlay} onClick={onClose} />

      <div className={styles.popup}>
        <Text size='l' semibold className={styles.title}>
          {t('onboarding.getSelfieReportPopup.title')}
        </Text>

        <div className={styles.image}></div>

        <Button title={t('onboarding.getSelfieReportPopup.continue')} onClick={handleContinue} />
      </div>
    </>
  );
};
